import React from 'react';
import R from 'ramda';

class ExpandableTextBlock extends React.Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
    };
  }
  _toggle = () => {
    this.setState({ expanded: !this.state.expanded });
  };
  render() {
    const isString = R.is(String, this.props.children);
    if (!isString || !this.props.children) return this.props.children || <span/>;
    const textLength = this.props.children ? this.props.children.length : 0;
    const tooLong = textLength > 500;
    return (
      <span>
        <span className={this.props.className} style={this.props.style}>
          {
            !this.state.expanded ? (this.props.children || '').slice(0, 500) : this.props.children
          }
        </span>
        <div>
          <a style={{ cursor: 'pointer' }} onClick={this._toggle} >
            {
              !this.state.expanded && tooLong && ' + Show All'
            }
            {
              this.state.expanded && tooLong && ' - Show Less'
            }
          </a>
        </div>
      </span>
    )
  }
}

ExpandableTextBlock.propTypes = {
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  style: React.PropTypes.object,
};

export default ExpandableTextBlock;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/expandable-text-block.jsx